import React from 'react';
import CustomButton, {IconButton, SecondaryButton} from "./CustomButton";
import useDidMount from "../hooks/useDidMount";

//bodyClasses -> max-w-screen-sm, max-w-screen-md, max-w-screen-lg, max-w-screen-xl for different sizes
const CustomModal = ({
                       setShowModal, showModal, children, title = 'Head',
                       bodyClasses = "", onClick, disabled = false, buttonLabel, button, loading = false,
                       isPreviewModal = false, secondaryButtonLabel, childrenClass,
                       preFooterComponent
                     }) => {


  const close = () => {
    if (!loading && setShowModal) {
      setShowModal(false);
    }
  };

  useDidMount(() => {
    if (showModal) {
      document.body.style.overflowY = 'hidden';
      // document.body.style.position = 'fixed';
      // document.body.style.width = '100%';
    } else {
      document.body.style.overflowY = 'auto';
      // document.body.style.position = 'static';
    }
  }, [showModal]);

  return (
    <div
      className={`${showModal ? 'visible opacity-100 z-20' : 'invisible opacity-0 pointer-events-none -z-1'} fixed inset-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto transition-all flex justify-center items-center`}
    >
      <div className="fixed inset-0 w-full h-full bg-opacity-50 bg-rand-100" onClick={close}/>
      <div
        className={`${showModal ? 'translate-y-0' : '-translate-y-1/3'} modal relative w-full my-8 mx-4 pointer-events-none transition-all duration- transform`}>
        <div
          className={`${bodyClasses ? `${bodyClasses}` : ' max-w-screen-lg'} relative shadow-lg rounded-xl pointer-events-auto bg-white text-gray-800 mx-auto`}>
          <header className="flex items-center justify-between p-5 border-b border-gray-200">
            <h2 className="text-xl font-semibold" id="exampleHeader">{title}</h2>
            <div className="flex items-center">
              {loading ?
                <svg className="-mx-1 animate-spin h-7 w-7 text-secondary-500" xmlns="http://www.w3.org/2000/svg"
                     style={{marginTop: 2, marginBottom: 1}}
                     fill="none"
                     viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path className="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                </svg> :
                <IconButton onClick={close} iconColor="text-rand-100" className="bg-transparent w-8 h-8" size="2xl"/>
              }

            </div>


          </header>
          <main className={`${isPreviewModal ? "bg-background " : ""}sm:p-5 p-3 overflow-y-auto max-modal-height ${childrenClass && ` ${childrenClass}`}`}>
            {children}
          </main>
          <footer className="flex justify-between p-5 border-t border-gray-200 items-center space-x-4">
            {!!preFooterComponent && preFooterComponent}
            <div className="flex items-center space-x-4 ml-auto">
              <SecondaryButton onClick={close} disabled={loading}>
                {secondaryButtonLabel ? secondaryButtonLabel : 'Cancel'}
              </SecondaryButton>
              {onClick &&
              <CustomButton disabled={disabled || loading} onClick={onClick}>{buttonLabel ? buttonLabel : 'Ok'}</CustomButton>}
              {button}
            </div>

          </footer>
        </div>
      </div>
    </div>
  );
};


export default React.memo(CustomModal);
